module.exports = __webpack_public_path__ + "static/media/nodejs-icon.94cafb0d.svg";